import styled from 'styled-components';
import { ButtonGroup, Icon } from '@appcues/sonar';
import { MenuHeading } from 'ext/components/ui';

export const Body = styled.div`
  ${ButtonGroup} {
    justify-content: flex-end;
    margin-top: var(--spacing-large);
  }
`;

export const ErrorMessage = styled.p`
  color: var(--color-error-500, #dc2626);
  font-size: var(--font-size-small);
  margin-top: var(--spacing-small);
  margin-bottom: 0;
`;

export const BottomMenuWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: absolute;
  left: 46px;
  bottom: calc(var(--bottom-bar-height) / 2);
  height: 40px;
  width: 58px;
  background: var(--color-neutral-600);
  background: var(--diel-gray);
  color: var(--color-neutral-0);
  border: none;
  border-radius: 6px;
  padding: 0 13px;
  transform: translate3d(-50%, 50%, 0);
  cursor: pointer;

  ${({ visible }) =>
    visible &&
    `
    background: var(--color-neutral-600);
    outline: 1px solid var(--color-neutral-0);
    `}

  svg path {
    fill: var(--color-neutral-0);
  }
`;

export const MenuWrapper = styled.div`
  position: absolute;
  bottom: 65px;
  left: 0;
  text-align: left;

  ${MenuHeading} {
    margin-left: var(--spacing-small);
  }
`;

export const LinkItem = styled.a`
  display: flex;
  flex: 1;
  text-decoration: none;
  color: var(--color-neutral-0);
`;

export const IconLabel = styled.div`
  display: flex;
  align-items: center;
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-semibold);
  text-align: left;
  cursor: pointer;

  ${Icon} {
    min-width: 30px;
    margin-right: var(--spacing-x-small);
    padding: 0px 6px;
  }

  ${({ disabled }) =>
    disabled &&
    `
      cursor: not-allowed;
      color: var(--color-neutral-500);

      && svg path {
        fill: var(--color-neutral-500);
      }
  `}
`;
